<template>
  <a class="w-full pt-4 block cursor-pointer" href="/">
    <img src="../../breakmoods/public/img/logo/logoWordBlack.png" alt="Break Moods Logo" class="h-(--height-header-img-form) mx-auto" />
  </a>
  <RouterView />
</template>

<script setup>

</script>

